<a (click)="onMenuItemSelected($event)"
  class="scitis-menu-item-content"
  [ngClass]="menuItem.isFavorite ? 'scitis-menu-item-content-favorite' : ''"
  href="#">
  <span class="menu-item-icon">
    <span [ngClass]="iconClass"></span>
  </span>
  @if (useHighlighting) {
    <ngb-highlight class="d-block truncate" [result]="menuItem.name" [term]="highlightTerms"
    ></ngb-highlight>
  }
  @if (!useHighlighting) {
    <span class="menu-item-title">
      @if (menuItem.disabled) {
        <span class="fa-solid fa-eye-slash mr-2"
          placement="top-left"
          container="body"
          [ngbTooltip]="'Content may not be visible to your user.' | translate"
        ></span>
      }
      <span [innerText]="menuItemName" [title]="menuItemName"></span>
      @if (isLoadingMenuItemParent) {
        <span class="fa-solid fa-spinner fa-spin ml-1"></span>
      }
    </span>
  }

  @if (menuItem.favoriteToggle && !menuItem.disabled) {
    <div class="menu-item-functions">
      <button (click)="toggleFavorite($event)"
        [ngbTooltip]="tooltip | async"
        class="btn btn-xs btn-secondary text-white"
        container="body"
        placement="right"
        tooltipClass="text-nowrap">
        <span [ngClass]="menuItem.isFavorite ? 'fa-solid fa-star' : 'fa-solid fa-star'"></span>
      </button>
    </div>
  }
</a>

@if (currentNodeIsSelected) {
  <div>
    @if (!expandNodeInProgress) {
      <scitis-node-detail
        [nodeUserMenuItems]="nodeUserMenuItems"
        [interactiveDataAnalysisItemToRedirect]="interactiveDataAnalysisMenuItem"
        [showNodeUserMenuItems]="showNodeUserMenuItems"
        [firebaseUserId]="firebaseUserId">
      </scitis-node-detail>
    }
  </div>
}

